import React from "react";
import "./HtmlElement.css";

interface HtmlElementProps {
  elements: string;
  className?: string;
}

const HtmlElement: React.FC<HtmlElementProps> = (props) => {
  return <div className={props.className} dangerouslySetInnerHTML={{ __html: props.elements }} />;
};

export default HtmlElement;
